import React, { useEffect } from "react";
import { Html5Qrcode } from "html5-qrcode";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Camera, X } from "lucide-react";

/**
 * La fotocamera puntata sull'etichetta dello scaffale.
 *
 * L'etichetta porta l'indirizzo della pagina pubblica dell'articolo: da li'
 * si tiene solo il codice, che e' quello che serve per aggiungere la riga.
 */
export default function MaterialeQRScanner({ onClose, onScanned }) {
  useEffect(() => {
    let scanner;
    const avvia = async () => {
      try {
        scanner = new Html5Qrcode("materiale-qr-box");
        await scanner.start({ facingMode: "environment" }, { fps: 10, qrbox: 220 },
          (letto) => {
            const m = letto.match(/materiale\/([A-Za-z0-9_-]+)/i);
            if (m) scanner.stop().then(() => onScanned(m[1]));
          }, () => {});
      } catch (e) {
        if (process.env.NODE_ENV !== "production") console.warn("QR scanner error:", e);
        toast.error("Camera non disponibile. Cerca l'articolo per nome.");
        onClose();
      }
    };
    avvia();
    return () => { if (scanner?.isScanning) scanner.stop().catch(() => {}); };
  }, [onClose, onScanned]);

  return (
    <div className="fixed inset-0 bg-slate-900/90 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg p-4 max-w-md w-full">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-display font-bold flex items-center gap-2">
            <Camera className="w-4 h-4" /> Inquadra l'etichetta
          </h3>
          <Button variant="outline" size="sm" onClick={onClose}><X className="w-4 h-4" /></Button>
        </div>
        <div id="materiale-qr-box" className="w-full" />
        <p className="text-xs text-slate-500 mt-3 text-center">
          Il QR stampato sullo scaffale, sotto l'articolo che stai prendendo.
        </p>
      </div>
    </div>
  );
}
